import { createContext } from 'react';
import type {
  AuthUser,
  ProfileFormInput,
  SignInInput,
  SignUpInput,
} from '../../domain/entities/auth.entity';

export interface AuthContextValue {
  user: AuthUser | null;
  /** `true` enquanto a sessão salva ainda está sendo lida. */
  isRestoring: boolean;
  signIn: (input: SignInInput) => Promise<AuthUser>;
  signUp: (input: SignUpInput) => Promise<AuthUser>;
  /** Cria o perfil desta plataforma para a conta já logada sem ele. */
  completeRegistration: (input: ProfileFormInput) => Promise<AuthUser>;
  /**
   * O back respondeu 403 (sem perfil aqui) para uma sessão que o front achava
   * completa — ex.: sessão restaurada de antes. Corrige o estado local para a
   * tela pedir o cadastro curto.
   */
  markProfileMissing: () => void;
  forgotPassword: (email: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
